import { ProgressBarStyle } from './progress-bar.style';

export function ProgressBar({ progress }: { progress: number }) {
  return (
    <ProgressBarStyle.Container>
      <ProgressBarStyle.Bar style={{ width: `${progress * 100}%` }} />
    </ProgressBarStyle.Container>
  );
}
